import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		isMobile: /(iPhone|iPad|iPod|Android)/gi.test(navigator.userAgent),
		isAndroid: /(Android)/gi.test(navigator.userAgent),
		isIOS: /(iPhone|iPad|iPod)/gi.test(navigator.userAgent),
		isWebkit: /(AppleWebkit)/gi.test(navigator.userAgent),
		isFirefoxIOS: /(FxiOS)/gi.test(navigator.userAgent),
		isOperaIOS: /(OPiOS)/gi.test(navigator.userAgent),
		isChromeIOS: /(CriOS)/gi.test(navigator.userAgent),
		isMercury: /(mercury)/gi.test(navigator.userAgent),
		region: environment.region,
		productId: null,
		showLoadingOverlay: true,
		loadingOverlayLabel: '',
		appType: 'web',
		channel: null,
		balanceData: {},
		productsData: {},
		accountData: {},
	},
	getters: {
		// balance  data:
		balanceCurrency(state) {
			return state.balanceData.currency;
		},
		totalBalanceAmount(state) {
			return state.balanceData.totalAmount;
		},
		// account data:
		isVerifiedEmail(state) {
			return state.accountData.isVerifiedEmail;
		},
		isEUCountry(state) {
			return state.accountData.isEUCountry;
		},
		email(state) {
			return state.accountData.email;
		},
		// products data:
		currency(state) {
			return state.productsData.currency;
		},
		productType(state) {
			return state.productsData.productType;
		},
		products(state) {
			return state.productsData.products;
		},
	},
	mutations: {
		setChannel(state, payload) {
			state.channel = payload;
		},
		setAppType(state, payload) {
			state.appType = payload;
		},
		setProductId(state, payload) {
			state.productId = payload;
		},
		getRegion(state, payload) {
			state.region = payload;
		},
		startLoadingOverlay(state, payload) {
			state.loadingOverlayLabel = payload;
			state.showLoadingOverlay = true;
		},
		endLoadingOverlay(state) {
			state.showLoadingOverlay = false;
		},
		setBalanceData(state, payload) {
			state.balanceData = payload;
		},
		setProductsData(state, payload) {
			state.productsData = payload;
		},
		setAccountData(state, payload) {
			state.accountData = payload;
		},
	},
});
